import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import MaskedInput from 'react-maskedinput';
import { Alert, Button, Col, ControlLabel, FormControl, Label, Panel, Row, Table } from 'react-bootstrap';
import { FormGroupWrapper, ViewWrapper } from './styles';
import { ISerologyTracking } from '@nkr/models/index';
import { SerologyListType } from '@nkr/store/index';
import styled from 'styled-components';

const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }
`;

interface IProps {
    centerId: number,
    data: ISerologyTracking,
    listType: SerologyListType,
    onDataChange: (data: ISerologyTracking) => void,
    onSavePanel: (data: ISerologyTracking) => void
}

interface IState {
    showNotification: boolean,
    notificationSelection: number,
    deadlineDateValid: boolean,
    dirty: boolean
}

class View extends React.Component<IProps, IState> {
    readonly state: IState = {
        showNotification: false,
        notificationSelection: -1,
        deadlineDateValid: true,
        dirty: false
    }

    container: HTMLDivElement;

    componentDidMount = () => { }

    handleFieldChange = (e: React.FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let id = e.currentTarget.id;
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;
        let data = _.cloneDeep(this.props.data);

        if (id == 'statusDeadline') {
            data.statusDeadline = value;
        }

        this.props.onDataChange(data);
    }

    handleSavePanel = () => {
        let { deadlineDateValid } = this.validate();
        let isValid = deadlineDateValid;

        let data = _.cloneDeep(this.props.data);

        this.setState({
            deadlineDateValid,
            dirty: true
        }, () => {
            if (isValid) {
                this.props.onSavePanel(data)
            };
        });
    }

    validate = () => {
        return {
            deadlineDateValid: this.props.data.statusDeadline != ''
        };
    }

    handleAddEditCancel = () => {
        this.setState({
            showNotification: false,
            notificationSelection: -1
        })
    }

    handleShowNotification = (noteselect: number) => {
        this.setState({
            showNotification: true,
            notificationSelection: noteselect
        });
    }

    render = () => {
        if (this.props.data == null)
            return null;

        const { deadlineDateValid, dirty } = this.state;
        const isValid = dirty ? deadlineDateValid : true;

        return (
            <>
                <ViewWrapper horizontal>
                    <div className='modal-container'>
                        {!isValid && (
                            <div className='row'>
                                <div className='col-xs-12 col-lg-12'>
                                    <Alert bsStyle='danger'>Patient Type: <br />
                                        Still editable by center, see 'Recipient Data' tab.
                                    </Alert>
                                </div>
                            </div>
                        )}

                        <div className='row' style={{ height: '10px' }}> </div>

                        <Panel>
                            <Panel.Heading>Swap Details</Panel.Heading>
                            <Panel.Body style={{ padding: '10px 5px' }}>
                                <FormGroupWrapper>
                                    <FormGroupWrapper style={{ marginBottom: 0 }}>
                                        <Col xs={12} lg={5} componentClass={ControlLabel}>Recipient Alias:</Col>
                                        <Col xs={12} lg={7}><div className='form-control-static'>{this.props.data.recipientAlias}</div></Col>
                                    </FormGroupWrapper>

                                    <FormGroupWrapper>
                                        <Col xs={12} lg={5} componentClass={ControlLabel}>Donor Center:</Col>
                                        <Col xs={12} lg={7}><div className='form-control-static'>{this.props.data.donorCenter}</div></Col>
                                    </FormGroupWrapper>

                                    <FormGroupWrapper>
                                        <Col xs={12} lg={5} componentClass={ControlLabel}>Donor Alias:</Col>
                                        <Col xs={12} lg={7}><div className='form-control-static'>{this.props.data.donorAlias}</div></Col>
                                    </FormGroupWrapper>

                                    <FormGroupWrapper>
                                        <Col xs={12} lg={5} componentClass={ControlLabel}>Recipient Center:</Col>
                                        <Col xs={12} lg={7}><div className='form-control-static'>{this.props.data.recipientCenter}</div></Col>
                                    </FormGroupWrapper>

                                    <FormGroupWrapper>
                                        <Col xs={12} lg={5} componentClass={ControlLabel}>Swap Number:</Col>
                                        <Col xs={12} lg={7}><div className='form-control-static'>{this.props.data.chainNumber}/{this.props.data.clusterNumber}/{this.props.data.positionNumber}</div></Col>
                                    </FormGroupWrapper>

                                    <Col xs={12} lg={5} componentClass={ControlLabel}>Deadline Date:</Col>

                                    <Col xs={12} lg={7}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ marginRight: 5 }}>
                                                <MaskedInput
                                                    id='statusDeadline'
                                                    mask='11/11/1111'
                                                    placeholder='mm/dd/yyyy'
                                                    className='form-control'
                                                    disabled={this.props.listType == SerologyListType.Closed}
                                                    value={moment(this.props.data.statusDeadline).format('MM/DD/YYYY')}
                                                    onChange={this.handleFieldChange} />
                                            </div>
                                        </div>
                                    </Col>
                                </FormGroupWrapper>
                            </Panel.Body>
                        </Panel>

                        <Panel>
                            <Panel.Heading>Serology Details</Panel.Heading>
                            <Panel.Body style={{ padding: '10px 5px' }}>
                                <FormGroupWrapper>
                                    <Col xs={12} lg={5} componentClass={ControlLabel}>Date Requested:</Col>
                                    <Col xs={12} lg={7}><div className='form-control-static'>{this.props.data.requestedDate != '' ? this.props.data.requestedDate : '--'}</div></Col>
                                </FormGroupWrapper>

                                <FormGroupWrapper>
                                    <Col xs={12} lg={5} componentClass={ControlLabel}>Date Shipped Out:</Col>
                                    <Col xs={12} lg={7}><div className='form-control-static'>{this.props.data.shipOutDate != '' ? this.props.data.shipOutDate : '--'}</div></Col>
                                </FormGroupWrapper>

                                <FormGroupWrapper>
                                    <Col xs={12} lg={5} componentClass={ControlLabel}>Date Shipped Back:</Col>
                                    <Col xs={12} lg={7}><div className='form-control-static'>{this.props.data.shipBackDate != '' ? this.props.data.shipBackDate : '--'}</div></Col>
                                </FormGroupWrapper>

                                <FormGroupWrapper>
                                    <Col xs={12} lg={5} componentClass={ControlLabel}>Date Received:</Col>
                                    <Col xs={12} lg={7}><div className='form-control-static'>{this.props.data.receivedDate != '' ? this.props.data.receivedDate : '--'}</div></Col>
                                </FormGroupWrapper>
                            </Panel.Body>
                        </Panel>

                        <div style={{ textAlign: 'center' }}>
                            <Button bsStyle='primary' bsSize='large' disabled={this.props.listType == SerologyListType.Closed} onClick={() => this.handleSavePanel()}>Save Changes</Button>
                        </div>
                        <div className='row' style={{ marginTop: 0, marginBottom: 10, height: 10 }}></div>
                    </div>
                </ViewWrapper>
            </>
        );
    }
}
export default View;